export default [
  {
    path: '/b/hasil-sensus',
    redirect: '/b/hasil-sensus',
    name: 'bHasilSensus',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bHasilSensusIndex',
        component: () => import('@/views/b/hasilSensus/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-hasil-sensus',
          pageTitle: 'Hasil Sensus BMD ',
          breadcrumb: [
            {
              text: 'Hasil Sensus BMD',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
